<dynamic-form
  [group]="formGroup"
  (cancelChange)="cancel()"
  (submitChange)="save()"
  [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubConfirmation.SubscriptionCodeMismatch' | translate">
  <ng-container class="content">
    <div class="page">
      <p>{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubConfirmation.CustomerDefinedCluSelected" | translate }}</p>
      <div class="footer-btn">
        <ssg-button
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubConfirmation.Confirm' | translate"
          name="save"
          (click)="Action(clubModelEnum.Save)"></ssg-button>
        <ssg-button
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubConfirmation.OptOut' | translate"
          name="cancel"
          (click)="Action(clubModelEnum.Cancel)"></ssg-button>
        <ssg-button
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.ClubFastaccess.ClubConfirmation.Placement' | translate"
          name="success"
          (click)="Action(clubModelEnum.Replace)"></ssg-button>
      </div>
    </div>
  </ng-container>
</dynamic-form>
